(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-BK"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const contactType = document.getElementById("ContactForm-type");
    const orderNumInput = document.getElementById("ContactForm-ordernum");
    const requiredLabel = document.getElementById("ordernum-required-label");
    const contactBtn = document.getElementById("btn-contact");
    
    contactType.addEventListener("change", function () {
      $('#type_invoice_attention').hide();
      if (contactType.value === "ご注文後のお問い合わせ") {
        orderNumInput.required = true;
        requiredLabel.style.display = "inline-flex";
      } else if (contactType.value === "請求書支払の申請") {
        $('#type_invoice_attention').show();
      } else {
        orderNumInput.required = false;
        requiredLabel.style.display = "none";
      }
    });

    contactBtn.addEventListener("click", function () {
      const regex = new RegExp(/^[a-zA-Z0-9]+$/);
      const orderNumber = orderNumInput.value;
      if (orderNumber && !regex.test(orderNumber)) {
        document.getElementById('order-number').innerHTML = "注文番号は半角英数字のみ入力してください。";
        return false;
      } else {
        document.getElementById("ContactForm").submit();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const contactType = document.getElementById("ContactForm-type");
    const orderNumInput = document.getElementById("ContactForm-ordernum");
    const requiredLabel = document.getElementById("ordernum-required-label");
    const contactBtn = document.getElementById("btn-contact");
    
    contactType.addEventListener("change", function () {
      $('#type_invoice_attention').hide();
      if (contactType.value === "ご注文後のお問い合わせ") {
        orderNumInput.required = true;
        requiredLabel.style.display = "inline-flex";
      } else if (contactType.value === "請求書支払の申請") {
        $('#type_invoice_attention').show();
      } else {
        orderNumInput.required = false;
        requiredLabel.style.display = "none";
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-banner-pc"] && !Shopify.designMode) return;
  try {
    
  
  const swiper = new Swiper(".swiper", {
    slidesPerView: 3,
    spaceBetween: 35, 
    grabCursor: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-loading"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load',function(){
    function loaderClose(){
      $("#loading").fadeOut();
    }
    setTimeout(loaderClose, 0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-content"] && !Shopify.designMode) return;
  try {
    
'use strict';
const tabMenus = document.querySelectorAll('.js_tab .tab');
tabMenus.forEach((tabMenu) => {
  tabMenu.addEventListener('click', tabSwitch);
})

function tabSwitch(e) {
  const tabTargetData = e.currentTarget.dataset.tab;
  const tabList = e.currentTarget.closest('.js_tab .tabs');
  const tabItems = tabList.querySelectorAll('.js_tab .tab');
  const tabPanelItems = tabList.
  nextElementSibling.querySelectorAll('.js_tab .tab__cnt');

  tabItems.forEach((tabItem) => {
    tabItem.classList.remove('is-active');
  })
  tabPanelItems.forEach((tabPanelItem) => {
    tabPanelItem.classList.remove('is-show');
  })

  e.currentTarget.classList.add('is-active');
  tabPanelItems.forEach((tabPanelItem) => {
    if (tabPanelItem.dataset.panel ===  tabTargetData) {
      tabPanelItem.classList.add('is-show');
    }
  })

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reminder"]) return;
  try {
    
  // アコーディオン - 新規登録
  document.addEventListener("DOMContentLoaded", function () {
    const content = document.querySelector('.js-accordion-cnt-add');

    document.querySelector('.js-accordion-add').addEventListener('click', function () {
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });

    // アコーディオンを閉じる処理
    document.querySelector('.js-accordion-close-add').addEventListener('click', function () {
      if (content) {
        content.style.maxHeight = null;
      }
    });
  });

  //--- アコーディオン - リスト
  document.addEventListener("DOMContentLoaded", function () {
    const accordionButtons = document.querySelectorAll(".js-accordion");
    const closeButtons = document.querySelectorAll('.js-accordion-close');

    accordionButtons.forEach(button => {
      button.addEventListener("click", function () {
        // const accordionContent = this.closest(".myreminder__listbox").nextElementSibling;
        // console.log(accordionContent);
        // if (accordionContent) {
        //   if (accordionContent.style.maxHeight) {
        //     accordionContent.style.maxHeight = null;
        //   } else {
        //     accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
        //   }
        // }
      });
    });
    // アコーディオンを閉じる処理
    closeButtons.forEach(button => {
      button.addEventListener('click', function () {
        const content = this.closest('li').querySelector('.js-accordion-cnt');
        if (content) {
          content.style.maxHeight = null;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
